const routeConstant = {
  // Designer
  designer: {
    home: {
      path: "/designer/home",
      title: "Dashboard",
      uploadRevision: {
        path: "/designer/upload-revision",
        title: "Upload Revision",
      },
    },
    allProjects: {
      path: "/designer/projects",
      title: "All Projects",
    },
    myProjects: {
      path: "/designer/my-projects",
      title: "My Projects",
    },
    archivedProjects: {
      path: "/designer/archived-projects",
      title: "Archived Projects",
    },
    projectDetail: {
      path: "/designer/projects/:id",
      title: "Project Detail",
      thread: {
        path: "/designer/projects/:id/chat-thread",
        title: "Thread",
      },
    },
    accountSetting: {
      path: "/designer/account-setting",
      title: "Account Settings",
    },
    notifications: {
      path: "/designer/notifications",
      title: "History",
    },
  },

  // Client
  client: {
    projects: {
      path: "/client/projects",
      title: "My Projects",
    },
    archivedProjects: {
      path: "/client/archived-projects",
      title: "Archived Projects",
    },
    projectDetail: {
      path: "/client/projects/:id",
      title: "Project Detail",
      thread: {
        path: "/client/projects/:id/chat-thread",
        title: "Thread",
      },
    },
    notifications: {
      path: "/client/notifications",
      title: "History",
    },
    accountSetting: {
      path: "/client/account-setting",
      title: "Account Settings",
    },
    contact: {
      path: "/client/contact",
      title: "Contact Support",
    },
    documents: {
      path: "/client/documents",
      title: "Documents",
    },
  },

  // Collaborator
  collaborator: {
    projects: {
      path: "/collaborator/projects",
      title: "My Projects",
    },
    archivedProjects: {
      path: "/collaborator/archived-projects",
      title: "Archived Projects",
    },
    projectDetail: {
      path: "/collaborator/projects/:id",
      title: "Project Detail",
      thread: {
        path: "/collaborator/projects/:id/chat-thread",
        title: "Thread",
      },
    },
    notifications: {
      path: "/collaborator/notifications",
      title: "History",
    },
    accountSetting: {
      path: "/collaborator/account-setting",
      title: "Account Settings",
    },
    contact: {
      path: "/collaborator/contact",
      title: "Contact Support",
    },
    documents: {
      path: "/collaborator/documents",
      title: "Documents",
    },
  },

  // builder

  builder: {
    projects: {
      path: "/builder/projects",
      title: "Projects",
    },
    archivedProjects: {
      path: "/builder/archived-projects",
      title: "Archived Projects",
    },
    projectDetail: {
      path: "/builder/projects/:id",
      title: "Project Detail",
      thread: {
        path: "/builder/projects/:id/chat-thread",
        title: "Thread",
      },
    },
    accountSetting: {
      path: "/builder/account-setting",
      title: "Account Settings",
    },
    notifications: {
      path: "/builder/notifications",
      title: "History",
    },
  },

  // Auth
  login: {
    path: "/auth/login",
    title: "Login",
  },
  forgotPassword: {
    path: "/auth/forgot-password",
    title: "Forgot Password",
  },
  resetPassword: {
    path: "/auth/reset-password",
    title: "Reset Password",
  },
  setPassword: {
    path: "/auth/set-password",
    title: "Set Password",
  },
  onboarding: {
    path: "/auth/onboarding",
    title: "Onboarding",
  },

  // Public
  portalWalkthrough: {
    path: "/portal-walkthrough",
    title: "Portal Walkthrough",
  },
};

export { routeConstant };
